import { useEffect } from 'react';

/**
 * Hook that triggers a callback when the browser tab becomes visible.
 * Useful for re-syncing state on mobile browsers after backgrounding.
 */
export function useVisibilityChange(onVisible: () => void) {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        onVisible();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [onVisible]);
}
